import { useEffect, useState } from 'react';

import viewProviders from '@/shared/api/fulfilment/providers/viewProviders';
import useRedirectLogin from '@/shared/hooks/useRedirectLogin';
import Provider from '@/shared/types/fulfilment/provider.type';

const useFetchFulfilmentProviders = () => {
  const redirectLogin = useRedirectLogin();

  const [fulfilmentProviders, setFulfilmentProviders] = useState<
    Provider[] | null
  >(null);

  useEffect(() => {
    const fetchFulfilmentProviders = async () => {
      const response = await viewProviders({
        body: {},
        onUnauthorized: redirectLogin,
      });

      if (response.success) {
        setFulfilmentProviders(response.data);
      }
    };

    void fetchFulfilmentProviders();
  }, [redirectLogin]);

  return { fulfilmentProviders };
};

export default useFetchFulfilmentProviders;
